import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '26px 30px',
    fontSize: 20,
    fontWeight: 300,
    display: 'flex',
    alignItems: 'center',
    '& .MuiTypography-root': {
      fontSize: 20,
      fontWeight: 600
    }
  },
  sideBarRoot: {
    margin: 0,
    fontSize: 20,
    fontWeight: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 12,
    paddingBottom: '4px !important',
    paddingRight: 18,
    paddingLeft: 30,
    '& .MuiTypography-root': {
      fontSize: 20,
      fontWeight: 600
    }
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 20,
    fontSize: 18,
    color: '#e0e0e0',
  },
  sideBarCloseButton: {
    // position: 'absolute',
    // right: theme.spacing(1),
    // top: 16,
    fontSize: 18,
    color: '#c0c0c0',
  },
});
export const DialogContent = withStyles((theme) => ({
  root: {
    padding: 30,
    paddingTop: 24,
  },
}))(MuiDialogContent);
export const TripActionDialogContent = withStyles((theme) => ({
  root: {
    padding: '16px 24px',
  },
}))(MuiDialogContent);
export const SideBarDialogContent = withStyles((theme) => ({
  root: {
    padding: '24px',
    position: 'relative'
  },
}))(MuiDialogContent);

export const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '21px 30px',
    '& .modal-save-cta': {
      padding: '9px 26px 11px 28px',
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
      backgroundColor: '#09101e',
      fontSize: 14,
      fontWeight: 300,
      color: '#fff',
      height: 36,
      textTransform: 'capitalize'
    },
    '& .modal-save-cta-blue': {
      padding: '9px 26px 11px 28px',
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
      backgroundColor: '#0033cc',
      fontSize: 14,
      fontWeight: 'bold',
      color: '#fff',
      height: 36,
      textTransform: 'capitalize'
    },
    '& .modal-save-cta-outlined': {
      padding: '14px',
      borderRadius: 4,
      border: '1px solid white',
      fontSize: 14,
      fontWeight: 300,
      color: '#0033cc',
      height: 36,
      letterSpacing: '1px'
    },
    '& .modal-disable-cta': {
      padding: '9px 26px 11px 28px',
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
      backgroundColor: 'lightgrey',
      fontSize: 14,
      fontWeight: 'bold',
      color: '#fff',
      height: 36,
      textTransform: 'capitalize'
    },
    '& .modal-close-cta': {
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05)',
      border: 'solid 1px #d8dce6',
      backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff)',
      fontSize: 14,
      fontWeight: 300,
      height: 36,
      textTransform: 'capitalize'
    },
    '& .modal-close-cta-outlined': {
      borderRadius: 4,
      border: 'solid 1px white',
      color: 'grey',
      fontSize: 14,
      fontWeight: 300,
      height: 36,
      letterSpacing: '1px',
      padding: '14px'
    }
  },
}))(MuiDialogActions);
export const SideBarDialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '21px 30px',
    '& .modal-save-cta': {
      padding: '9px 26px 11px 28px',
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
      backgroundColor: '#09101e',
      fontSize: 14,
      fontWeight: 300,
      color: '#fff',
      height: 36,
      textTransform: 'capitalize'
    },
    '& .modal-save-trip-cta': {
      padding: '9px 26px 11px 28px',
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
      backgroundColor: '#5170f0',
      fontSize: 14,
      fontWeight: 'bold',
      color: '#fff',
      height: 36,
      textTransform: 'capitalize',
      letterSpacing: '1px'
    },
    '& .modal-close-cta': {
      borderRadius: 4,
      boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05)',
      border: 'solid 1px #d8dce6',
      backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff)',
      fontSize: 14,
      fontWeight: 300,
      height: 36,
      textTransform: 'capitalize'
    }
  },
}))(MuiDialogActions);
export const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
export const SideBarDialogTitle = withStyles(styles)((props) => {
  const { children,onEdit,onDelete, classes, onClose, siderBarType, ...other } = props;
  return (
    <MuiDialogTitle disableTypography classes={{ root: classes.sideBarRoot }} {...other}>
      <Typography variant="h6">{children}</Typography>
      <div style={{marginLeft:'auto'}}>
      {onEdit ? (
        <IconButton variant="outlined" style={{ borderRadius: '4px', border: '1px solid #0033cc', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px' }} onClick={onEdit} >
          <EditIcon style={{ color: '#0033cc', fontSize: '16px' }} />
        </IconButton>
      ) : null}
      {onDelete ? (
        <IconButton variant="outlined" style={{ borderRadius: '4px', border: '1px solid red', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px', marginLeft: '16px' }} onClick={onDelete} >
          <DeleteIcon style={{ color: 'red', fontSize: '16px' }} />
        </IconButton>
      ) : null}
      </div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.sideBarCloseButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
export default DialogTitle;